export default __webpack_public_path__ + "static/media/IMG_3064.808744b2.jpeg";